import { StatusMark, lightTheme } from '@vgrubs/components';
import { CalloutSurface, CalloutTone } from './Callout.styled';

type Props = {
  /**
   * Red for what goes wrong, yellow for what will if nobody acts, green for
   * done, blue for a plain aside.
   */
  tone: CalloutTone;
  children: React.ReactNode;
};

export const Callout = ({ tone, children }: Props) => {
  // Read at render time: a theme value pulled from the barrel at module level
  // is undefined in an eagerly loaded file.
  const markColor: Record<CalloutTone, string> = {
    danger: lightTheme.primary,
    warning: lightTheme.yellow,
    success: lightTheme.green,
    info: lightTheme.blue,
  };

  return (
    <CalloutSurface $tone={tone}>
      <StatusMark $color={markColor[tone]} />
      {children}
    </CalloutSurface>
  );
};
